import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { collection, getDocs, deleteDoc, doc, orderBy, query } from 'firebase/firestore';
import { db } from '../../firebase';
import { UserAuth } from '../../context/AuthContext';
import './UserArea.css';

const useCollection = (name) => {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    const reload = async () => {
        setLoading(true);
        const q = query(collection(db, name), orderBy('updatedAt', 'desc'));
        const snap = await getDocs(q);
        setItems(snap.docs.map(d => ({ id: d.id, ...d.data() })));
        setLoading(false);
    };

    useEffect(() => { reload(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return { items, loading, reload };
};

const UserArea = () => {
    const { user, logout } = UserAuth();
    const navigate = useNavigate();
    const projects = useCollection('project_reports');
    const events = useCollection('events');

    const handleLogout = async () => {
        await logout();
        navigate('/');
    };

    const handleDelete = async (collectionName, id, reload) => {
        if (!window.confirm('Diesen Eintrag wirklich löschen?')) return;
        await deleteDoc(doc(db, collectionName, id));
        reload();
    };

    return (
        <div className="userarea">
            <header className="userarea-header">
                <div>
                    <p className="userarea-eyebrow">Team-Bereich</p>
                    <h1>Willkommen{user?.email ? `, ${user.email}` : ''}</h1>
                </div>
                <button className="userarea-logout" onClick={handleLogout}>Abmelden</button>
            </header>

            <section className="userarea-section">
                <div className="userarea-section-header">
                    <h2>Projektberichte</h2>
                    <Link className="userarea-add-btn" to="/userarea/projekte/neu">+ Neuer Projektbericht</Link>
                </div>
                {projects.loading ? (
                    <p className="userarea-empty">Lädt…</p>
                ) : projects.items.length === 0 ? (
                    <p className="userarea-empty">Noch keine Projektberichte.</p>
                ) : (
                    <ul className="userarea-list">
                        {projects.items.map(item => (
                            <li key={item.id} className="userarea-list-item">
                                <span className="userarea-list-title">{item.title}</span>
                                <span className="userarea-list-actions">
                                    <Link to={`/userarea/projekte/${item.id}/bearbeiten`}>Bearbeiten</Link>
                                    <button onClick={() => handleDelete('project_reports', item.id, projects.reload)}>Löschen</button>
                                </span>
                            </li>
                        ))}
                    </ul>
                )}
            </section>

            <section className="userarea-section">
                <div className="userarea-section-header">
                    <h2>Veranstaltungen</h2>
                    <Link className="userarea-add-btn" to="/userarea/veranstaltungen/neu">+ Neue Veranstaltung</Link>
                </div>
                {events.loading ? (
                    <p className="userarea-empty">Lädt…</p>
                ) : events.items.length === 0 ? (
                    <p className="userarea-empty">Noch keine Veranstaltungen.</p>
                ) : (
                    <ul className="userarea-list">
                        {events.items.map(item => (
                            <li key={item.id} className="userarea-list-item">
                                <span className="userarea-list-title">{item.title}</span>
                                <span className="userarea-list-actions">
                                    <Link to={`/userarea/veranstaltungen/${item.id}/bearbeiten`}>Bearbeiten</Link>
                                    <button onClick={() => handleDelete('events', item.id, events.reload)}>Löschen</button>
                                </span>
                            </li>
                        ))}
                    </ul>
                )}
            </section>
        </div>
    );
};

export default UserArea;
